import React from "react";

const USDCoinERCIcon = ({ className }) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1364_7173)">
      <path
        d="M16 32C19.1646 32 22.258 31.0616 24.8892 29.3035C27.5204 27.5454 29.5711 25.0466 30.7821 22.1229C31.9931 19.1993 32.31 15.9823 31.6926 12.8786C31.0753 9.77487 29.5514 6.92394 27.3138 4.6863C25.0761 2.44866 22.2252 0.924806 19.1215 0.307443C16.0178 -0.309921 12.8007 0.00693248 9.87711 1.21793C6.9535 2.42894 4.45464 4.4797 2.69654 7.11088C0.938432 9.74207 4.84406e-05 12.8355 4.84406e-05 16C-0.00513159 18.1026 0.405185 20.1855 1.20743 22.1291C2.00967 24.0726 3.18802 25.8385 4.67479 27.3253C6.16156 28.812 7.92744 29.9904 9.87099 30.7926C11.8145 31.5949 13.8974 32.0052 16 32Z"
        fill="#2775CA"
      />
      <path
        d="M20.4002 18.5337C20.4002 16.2065 19.0009 15.3992 16.2009 15.0661C14.1995 14.7999 13.8009 14.2661 13.8009 13.3337C13.8009 12.4014 14.4671 11.7992 15.7995 11.7992C17.0009 11.7992 17.6671 12.1992 18.0002 13.1999C18.036 13.2963 18.1005 13.3794 18.185 13.438C18.2696 13.4965 18.3701 13.5277 18.4729 13.5272H19.5391C19.6009 13.5288 19.6623 13.5178 19.7197 13.4949C19.777 13.472 19.8291 13.4377 19.8728 13.394C19.9165 13.3503 19.9508 13.2982 19.9737 13.2408C19.9966 13.1835 20.0076 13.122 20.006 13.0603V12.9948C19.8772 12.2723 19.5134 11.6125 18.971 11.118C18.4286 10.6235 17.7381 10.322 17.0067 10.2603V8.66029C17.0067 8.39411 16.806 8.19484 16.4729 8.12793H15.4722C15.206 8.12793 15.0067 8.3272 14.9398 8.66029V10.1992C12.934 10.4727 11.6671 11.7992 11.6671 13.4661C11.6671 15.6668 13.0009 16.5337 15.8009 16.8668C17.6671 17.1999 18.2737 17.5941 18.2737 18.6661C18.2737 19.7381 17.3413 20.4668 16.0744 20.4668C14.3406 20.4668 13.7471 19.7396 13.5406 18.733C13.5215 18.6206 13.4636 18.5184 13.377 18.4442C13.2903 18.3701 13.1804 18.3287 13.0664 18.3272H11.9275C11.8658 18.3258 11.8044 18.3369 11.7472 18.3599C11.6899 18.3829 11.6379 18.4172 11.5942 18.4609C11.5506 18.5045 11.5162 18.5565 11.4933 18.6138C11.4703 18.6711 11.4592 18.7324 11.4606 18.7941V18.861C11.7282 20.5279 12.7944 21.7279 14.9951 22.061V23.661C14.9951 23.9272 15.1944 24.1279 15.5275 24.1948H16.5282C16.7944 24.1948 16.9951 23.9941 17.0606 23.661V22.061C19.0606 21.7279 20.3944 20.3272 20.3944 18.5279L20.4002 18.5337Z"
        fill="white"
      />
      <path
        d="M12.5994 25.5331C10.6812 24.8295 9.02526 23.554 7.85541 21.8788C6.68557 20.2037 6.05825 18.2098 6.05825 16.1666C6.05825 14.1234 6.68557 12.1295 7.85541 10.4543C9.02526 8.77919 10.6812 7.50362 12.5994 6.80004C12.7274 6.74468 12.8349 6.65071 12.9069 6.53127C12.9789 6.41183 13.0117 6.27289 13.0009 6.13386V5.20004C13.0099 5.07755 12.9741 4.95596 12.9003 4.8578C12.8265 4.75965 12.7196 4.69158 12.5994 4.66622C12.5056 4.65643 12.4113 4.68013 12.3333 4.73313C9.90622 5.50455 7.78762 7.02828 6.28412 9.08378C4.78062 11.1393 3.97021 13.6199 3.97021 16.1666C3.97021 18.7133 4.78062 21.1939 6.28412 23.2494C7.78762 25.3049 9.90622 26.8286 12.3333 27.6C12.3887 27.6322 12.451 27.6509 12.515 27.6544C12.579 27.6578 12.6429 27.6461 12.7015 27.6202C12.7601 27.5942 12.8117 27.5547 12.8521 27.5049C12.8926 27.4552 12.9206 27.3965 12.934 27.3339C13.0009 27.2669 13.0009 27.2 13.0009 27.0662V26.1339C13.0009 25.9331 12.8002 25.6669 12.5994 25.5331ZM19.6671 4.73313C19.6115 4.70093 19.5492 4.68236 19.4851 4.67895C19.421 4.67554 19.357 4.68738 19.2983 4.7135C19.2397 4.73962 19.1881 4.77928 19.1478 4.82922C19.1075 4.87916 19.0795 4.93795 19.0663 5.00077C19.0009 5.06622 19.0009 5.13313 19.0009 5.26695V6.19931C19.0121 6.33376 19.054 6.46385 19.1234 6.57958C19.1927 6.69532 19.2876 6.79362 19.4009 6.86695C21.3191 7.57053 22.9751 8.8461 24.1449 10.5212C25.3148 12.1964 25.9421 14.1903 25.9421 16.2335C25.9421 18.2767 25.3148 20.2706 24.1449 21.9457C22.9751 23.6209 21.3191 24.8965 19.4009 25.6C19.273 25.6554 19.1657 25.7495 19.094 25.8689C19.0223 25.9884 18.9897 26.1273 19.0009 26.2662V27.2C18.9919 27.3223 19.0274 27.4437 19.1009 27.5419C19.1744 27.64 19.281 27.7082 19.4009 27.7339C19.4947 27.7436 19.589 27.7199 19.6671 27.667C22.0932 26.8849 24.2087 25.3534 25.7094 23.2929C27.2101 21.2325 28.0186 18.7491 28.0186 16.2C28.0186 13.651 27.2101 11.1676 25.7094 9.10714C24.2087 7.04665 22.0932 5.51522 19.6671 4.73313Z"
        fill="white"
      />
    </g>
    <g clip-path="url(#clip1_1364_7173)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9648 18C28.7449 18 30.4849 18.5278 31.965 19.5168C33.445 20.5057 34.5986 21.9113 35.2798 23.5558C35.9609 25.2004 36.1392 27.01 35.7919 28.7558C35.4446 30.5016 34.5875 32.1053 33.3288 33.364C32.0701 34.6226 30.4665 35.4798 28.7207 35.8271C26.9748 36.1743 25.1652 35.9961 23.5207 35.3149C21.8762 34.6337 20.4706 33.4802 19.4816 32.0001C18.4927 30.5201 17.9648 28.78 17.9648 27C17.9648 24.6131 18.9131 22.3239 20.6009 20.636C22.2887 18.9482 24.5779 18 26.9648 18V18Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9646 19.9326L29.3325 23.4704L31.7003 27.0091L26.9646 29.3949L22.229 27.0001L24.5968 23.4614L26.9646 19.9326ZM26.9646 30.3481L22.4916 27.9614L26.9646 34.0675L31.4376 27.9614L26.9646 30.3481Z"
        fill="#343434"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9648 19.9326L29.3327 23.4614L31.7005 27.0001L26.9648 25.2123V19.9326Z"
        fill="#343434"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9648 30.3476L31.4468 27.9609L26.9648 34.076V30.3476Z"
        fill="#313131"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9648 25.2119L31.7005 26.9996L26.9648 29.3855V25.2119Z"
        fill="#151515"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9646 19.9326L24.5968 23.4614L22.229 27.0001L26.9646 25.2123V19.9326Z"
        fill="#8C8C8C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9647 30.3476L22.4917 27.9609L26.9647 34.076V30.3476Z"
        fill="#8A8A8A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9646 25.2119L22.229 26.9996L26.9646 29.3855V25.2119Z"
        fill="#353535"
      />
    </g>
    <defs>
      <clipPath id="clip0_1364_7173">
        <rect width="32" height="32" fill="white" />
      </clipPath>
      <clipPath id="clip1_1364_7173">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(18 18)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default USDCoinERCIcon;
